import {
  AboutUsButtonElementDataType,
  AboutUsElementDataType,
} from '@/components/sections/builder/elements/body/about-us/type';
import { ElementProps } from '@/components/sections/builder/types';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { cn, isEmpty } from '@/lib/utils';
import { useBuilderStore } from '@/stores/builder';
import { SquareMousePointer } from 'lucide-react';
import Link from 'next/link';
import { shallow } from 'zustand/shallow';
import ShopIcon from '@/components/icons/shop-store-icon';
import { Checkbox } from '@/components/ui/checkbox';
import InputLink from '@/components/sections/builder/settings/input-link';

const defaultData: AboutUsButtonElementDataType = {
  name: 'Button',
  label: 'Shopping now',
  link: '#',
  showIcon: false,
};

export const ElementContent = ({ element }: ElementProps) => {
  const data = (element.data || defaultData) as AboutUsButtonElementDataType;
  const content = element.parentData as AboutUsElementDataType;

  return (
    <Link href={data.link || '#'}>
      <Button
        variant='default'
        className={cn(
          'inline-flex w-full items-center py-6',
          isEmpty(content.colorSchemeSection) && 'theme_button'
        )}
        style={
          !isEmpty(content.colorSchemeSection)
            ? {
                color: content.colorSchemeSection?.btnSolidlabel,
                backgroundColor: content.colorSchemeSection?.btnSolidBackgroud,
              }
            : {}
        }
      >
        {data.showIcon && <ShopIcon className='mr-2 h-5 w-5' />}
        {data.label}
      </Button>
    </Link>
  );
};

export const ElementSetting = ({ element }: ElementProps) => {
  const data = (element.data || defaultData) as AboutUsButtonElementDataType;
  const builder = useBuilderStore(
    (state) => ({
      setChildData: state.setChildData,
    }),
    shallow
  );

  return (
    <div>
      <span className='mb-2 flex text-sm'>Label button</span>
      <Input
        onChange={(e) =>
          builder.setChildData(element.parentId as string, element.id, {
            label: e.target.value,
          })
        }
        name='label'
        type='text'
        size={100}
        defaultValue={data.label || 'Read more'}
        className='w-full'
        placeholder='Label'
      />
      <span className='mb-2 mt-4 flex text-sm'>Link button</span>
      <InputLink
        name='link'
        placeholder='Search or enter a link'
        onChange={(value) => {
          builder.setChildData(element.parentId as string, element.id, {
            link: value,
          });
        }}
        value={data.link as string}
      />
      <div className='mt-4 flex items-center'>
        <Checkbox
          checked={data.showIcon}
          onCheckedChange={(value) =>
            builder.setChildData(element.parentId as string, element.id, {
              showIcon: !!value,
            })
          }
          className='mr-4'
        />
        <p>Show icon button</p>
      </div>
    </div>
  );
};

export const ElementPreviewIcon = SquareMousePointer;

const AboutUsButton = {
  type: 'button',
  group: 'about_us',
  defaultData,
  Element: ElementContent,
  Setting: ElementSetting,
  PreviewIcon: ElementPreviewIcon,
  Icon: ElementPreviewIcon,
  childs: [],
};

export default AboutUsButton;
